const FoldRight = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.21436 0.570251C4.58255 0.570251 4.88135 0.869054 4.88135 1.23724C4.88118 1.60529 4.58244 1.90326 4.21436 1.90326H2.21436V9.90326H4.21436C4.58254 9.90326 4.88134 10.2021 4.88135 10.5703C4.88135 10.9384 4.58255 11.2372 4.21436 11.2372H1.88135C1.32917 11.2372 0.881512 10.7894 0.881348 10.2372V1.57025C0.881359 1.01798 1.32907 0.570251 1.88135 0.570251H4.21436ZM7.74365 2.76556C8.00401 2.50546 8.42576 2.50532 8.68604 2.76556L11.353 5.43256C11.613 5.69285 11.613 6.11467 11.353 6.37494L8.68604 9.04193C8.42578 9.30209 8.00399 9.30195 7.74365 9.04193C7.4833 8.78158 7.4833 8.35892 7.74365 8.09857L9.27197 6.57025H4.21436C3.8463 6.5701 3.54834 6.27135 3.54834 5.90326C3.54857 5.53536 3.84644 5.2374 4.21436 5.23724H9.27197L7.74365 3.70795C7.48333 3.44759 7.48331 3.0259 7.74365 2.76556Z" />
    </svg>
  );
};

export default FoldRight;
